<!--模板界面-->
<template>
	<div class="centerMap">
		<!--<vchart style="width: 100%;height:5rem ;" ref='vchart' themes="UbiquitousOverviewChartSkin"></vchart>-->
		<!--<img src="/static/中科泛在定制/看板/centerMap.png" style="width: 100%;height: 100%;">-->
		<div id="zkMap" ref="myEchart"></div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	import echarts from "echarts";
	import '../../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				options: {}
			}
		},
		created() {},
		mounted() {
			this.chinaConfigure()
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			chinaConfigure() {
				let myChart = echarts.init(this.$refs.myEchart); //这里是为了获得容器所在位置    
				window.onresize = myChart.resize;
				myChart.setOption({ // 进行相关配置
					backgroundColor: "rgba(0,0,0,0)",
					tooltip: {
						show: false
					}, // 鼠标移到图里面的浮动提示框
					dataRange: {
						show: false,
						min: 1.2,
						max: 1000,
						text: ['High', 'Low'],
						realtime: true,
						calculable: true,
						color: ['#ec7f15']
					},
					geo: { // 这个是重点配置区
						map: 'china', // 表示中国地图
						roam: false, //禁用移动
						label: {
							normal: {
								show: false, // 是否显示对应地名
							}
						},
						scaleLimit: {
							max: 1.2,
							min: 1.2,
						},
						zoom: 1.2,
						itemStyle: {
							borderColor: '#3366cc',
							borderWidth: 1,
							borderType: 'solid',
							areaColor: '#0c0d49',
						},
						emphasis: {
							itemStyle: {
								areaColor: null,
								shadowOffsetX: 0,
								shadowOffsetY: 0,
								shadowBlur: 20,
								borderWidth: 0,
								shadowColor: 'rgba(51, 0, 0, 10)'
							},
							label: {
								show: false, // 是否显示对应地名
							},
						},
						regions: [{
							name: "南海诸岛",
							value: 0,
							itemStyle: {
								normal: {
									opacity: 0,
									label: {
										show: false
									}
								}
							}
						}]
					},
					series: [{
							type: 'scatter',
							coordinateSystem: 'geo' // 对应上方配置
						},
						{
							name: '启动次数', // 浮动框的标题
							type: 'map',
							geoIndex: 0,
							itemStyle: {
								opacity: 0,
							},
							data: [{
									name: "广东",
									value: 10
								},
								{
									name: "广西",
									value: 10
								},
								{
									name: "河北",
									value: 80
								},
								{
									name: "浙江",
									value: 10
								}
							]

						}
					]
				})
			}
		}
	}
</script>

<style scoped>
	p.bigTitle {
		width: 100%;
		color: #00C6FF;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		margin-top: 10px;
		margin-bottom: 5px;
	}
	
	.centerMap {
		height: 100%;
		width: 100%;
		background-image: url(/static/中科泛在定制/看板/mapbag.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	
	#zkMap {
		width: 100%;
		height: 100%;
	}
</style>